import { getErrorMessage } from "../../../../helper/getResponseMessage";
import axios from "../../../../util/axiosconfig";
import { showError } from "../../../../util/ShowStatus";

export const fetchDescriptionOfSurveySiteList = async (
  setDescriptionOfSurveySiteList: any,
  setIsDataLoading: any,
  toast: any
  // isPermitSpaceFormAttached: any,
  // currentFormValues: any,
  // safeSetSelectedDescriptionOfSurveySite: any
) => {
  try {
    setIsDataLoading(true);
    const response = await axios.get(
      `health-and-safety/survey-site-description-list`
    );
    setDescriptionOfSurveySiteList(response.data.result);
    // if (isPermitSpaceFormAttached) {
    //   safeSetSelectedDescriptionOfSurveySite(
    //     response.data.result.find(
    //       (item: any) =>
    //         item.siteName === currentFormValues?.surveySiteDescription
    //     )
    //   );
    // }
    setIsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsDataLoading(false);
    showError(error, toast);
  }
};

export const fetchPermitClosureReasonList = async (
  setPermitClosureReasonList: any,
  setIsDataLoading: any,
  toast: any
  // isPermitSpaceFormAttached: any,
  // currentFormValues: any,
  // safeSetSelectedPermitClosureReason: any
) => {
  try {
    setIsDataLoading(true);
    const response = await axios.get(
      `health-and-safety/permit-closure-reason-list`
    );
    setPermitClosureReasonList(response.data.result);
    //    if (isPermitSpaceFormAttached) {
    //   safeSetSelectedPermitClosureReason(
    //     response.data.result.find(
    //       (item: any) =>
    //         item.reason === currentFormValues?.permitClosureReason
    //     )
    //   );
    // }
    setIsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsDataLoading(false);
    showError(error, toast);
  }
};

export const fetchAllPermitSpaceEntryChecklistForm = async (
  setPermitSpaceEntryChecklist: any,
  setPermitSpaceEntryChecklistLoading: any,
  filters: any,
  toast: any,
  userIDs?: any
) => {
  try {
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      // Convert to UTC ISO string
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
      if (userIDs && userIDs.length > 0) {
        params.userIDs = userIDs.join(",");
      }
    }
    setPermitSpaceEntryChecklistLoading(true);
    const response = await axios.get(
      `health-and-safety/permit-confined-space-entry-form-list`,
      {
        params,
      }
    );
    setPermitSpaceEntryChecklist(response.data.result);
    setPermitSpaceEntryChecklistLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setPermitSpaceEntryChecklistLoading(false);
    showError(error, toast);
  }
};

export const getFormByFormID = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/permit-confined-space-entry-form-by-id?formID=${formIDParam}`
    );
    if (response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/health-and-safety/permit-for-confined-space-entry");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};

export const fetchUsersList = async (
  setUsersList: any,
  toast: any,
  setIsDataLoading?: any,
  isPermitSpaceFormAttached?: any,
  currentFormValues?: any,
  safeSetSelectedNames?: any
) => {
  try {
    setIsDataLoading && setIsDataLoading(true);
    const response = await axios.get(
      `health-and-safety/hs-submodule-mapping-wise-user-list?subModuleName=${encodeURIComponent(
        "Permit for Confined Space Entry"
      )}`
    );
    setUsersList(response.data.result);
    if (isPermitSpaceFormAttached) {
      safeSetSelectedNames(
        response.data.result.filter((user: any) =>
          currentFormValues?.name?.some(
            (selectedUser: any) => selectedUser.userID === user.userID
          )
        )
      );
    }
    setIsDataLoading && setIsDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setIsDataLoading && setIsDataLoading(false);
    showError(error, toast);
  }
};
